import React, { useState, useEffect, useContext } from "react";
import { app } from "../firebase.js";
import {
	getFirestore,
	collection,
	addDoc,
	doc,
	getDoc,
	serverTimestamp,
	query,
	where,
	getDocs,
	setDoc,
	updateDoc,
} from "firebase/firestore";

import { useAuth } from "../contexts/AuthContext";

const DatabaseContext = React.createContext();
export function useDatabase() {
	return useContext(DatabaseContext);
}

export function DatabaseProvider({ children }) {
	const [database, setDatabase] = useState();
	const { currentUser } = useAuth();

	useEffect(() => {
		setDatabase(getFirestore(app));
	}, []);

	const saveFiniteStateMachine = async (machine) => {
		const fsmCollection = collection(database, "finite-state-machines");
		machine.createdAt = serverTimestamp();
		machine.lastEdited = serverTimestamp();

		try {
			const docRef = await addDoc(fsmCollection, machine);
			return docRef;
		} catch (e) {
			console.error("Error adding document: ", e);
		}
	};
	const updateFiniteStateMachine = async (id, machine) => {
		const fsmCollection = collection(database, "finite-state-machines");
		const fsmRef = doc(fsmCollection, id);

		machine.lastEdited = serverTimestamp();

		try {
			await updateDoc(fsmRef, machine);
		} catch (e) {
			console.error("Error updating document: ", e);
		}
	};

	const getUserFSM = async () => {
		const fsmCollection = collection(database, "finite-state-machines");

		const fsmQuery = query(
			fsmCollection,
			where("userUID", "==", currentUser.uid)
		);

		const querySnapshot = await getDocs(fsmQuery);
		return querySnapshot;
	};
	const getFSM = async (id) => {
		const fsmCollection = collection(database, "finite-state-machines");
		const fsmRef = doc(fsmCollection, id);
		const docSnap = await getDoc(fsmRef);
		if (docSnap.exists()) {
			return docSnap.data();
		} else {
			return null;
		}
	};

	const value = {
		saveFiniteStateMachine,
		updateFiniteStateMachine,
		getUserFSM,
		getFSM,
	};
	return (
		<DatabaseContext.Provider value={value}>
			{children}
		</DatabaseContext.Provider>
	);
}
